
































import { Component } from "vue-property-decorator";
import { Base } from "@/components/common/base";
import { PaginationModel, VAction, VHeaders } from '@/models/pagedlistmodel';
import { vehicleInventoryService } from '@/shared';

@Component({
    props: ["methodName", "progress"],

    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
    components: {
        Grid: () => import("@/components/common/app.grid.vue"),
    }
})
export default class VehicleWholeSaleListingPage extends Base {
    public currentUserStoreId: number = 1;
    public paginations = new PaginationModel('id');
    public vehicleTransferList: any[] = [];
    public loading: boolean = false;
    public searchType: string = "SourceStockNumber";
    public vehicleTransferListColumns: VHeaders[] = [];
    public vehicleTransferListActions: VAction[] = [];

    public searchTypeList: any[] = [
        { id: "InBoundStockNumber", text: "InBound Stock Number" },
        { id: "SourceStockNumber", text: "Source Stock Number" }
    ];




    public created(): void {
        this.currentUserStoreId = this.userSession.storeId;
    }

    public beforeDestroy() {
        const buttons = [];
        this.$emit("updateToolBar", buttons);
    }

    public callMethod(methodName): void {
        if (methodName === "addVehicleSale") {
            this.$router
                .push({
                    name: "app.vehiclewholesale.add"

                })
                .catch((ex) => {
                    console.log(ex);
                });
        }
        this.resetMethodName(methodName);
    }
    public resetMethodName(methodName): void {
        if (methodName !== "") {
            this.$emit("resetMethodName", methodName);
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({
            id: "0",
            type: "button",
            title: "addVehicleTransfer",
            disabled: false,
            visible: true,
            class: "btn",
            label: "Add Vehicle Transfer",
            click: "addVehicleSale",
            icon: "fas fa-plus-circle",
        });
        this.$emit("updateToolBar", buttons);
    }

    public mounted() {

        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'vehicleWholesales');

        // Toolbar
        this.updateToolBar();
        this.$watch("methodtoCall", (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });
        this.setActions();
        this.setHeaders();
        this.GetVehicleTransferDetail();

    }
    public updatePaging(paging: any) {
        this.paginations = paging;
        this.GetVehicleTransferDetail();
    }
    public setActions() {
        this.vehicleTransferListActions = [
            {
                type: 'button',
                icon: 'fas fa-eye',
                title: 'View',
                action: (model, action: VAction) => {

                    this.$router.push({
                        name: 'app.vehiclewholesale.edit', params: {
                            id: model.id,
                        },
                    });

                },
            },
        ];
    }

    public setHeaders() {
        this.vehicleTransferListColumns = [
            {
                text: "Source Store",
                align: "center",
                value: "sourceStoreName",
                sortable: false,
            },
            {
                text: "Inbound Store",
                align: "center",
                value: "inboundStoreName",
                sortable: false,
            },
            {
                text: "Source Store Stock#",
                align: "center",
                value: "sourceStoreStockNumber",
                sortable: false,
            },
            {
                text: "Inbound Store Stock#",
                align: "center",
                value: "vehicleDetails.stockNumber",
                sortable: false,
            },
            {
                text: "Source Store Vehicle Cost",
                align: "center",
                value: "sourceStoreVehicleCost",
                sortable: false,
            },
            {
                text: "Inbound Store Vehicle Cost",
                align: "center",
                value: "saleAmount",
                sortable: false,
            },
            {
                text: "Posting Detail",
                align: "center",
                fieldType: 'template',
                template: (item) => {
                    if (item) {
                        if (item.isPostedToDms == true) {
                            return '<span class= "green kbd px-1"> Posted </span>';
                        } else if (item.vehicleDetails.isPosted
                            == true || item.isVehicleUpdated == true || (item.sourceStoreAccountingDetail && item.sourceStoreAccountingDetail.length > 0 && item.sourceStoreAccountingDetail[0]
                                .IsPosted == true) || (item.InboundStoreAccountingDetail && item.InboundStoreAccountingDetail.length > 0 && item.InboundStoreAccountingDetail[0].IsPosted == true)) {
                            return '<span class= " kbd px-1" style="background-color: #d76c77;"> Partial Posted </span>';
                        } else {
                            return '<span class= "red kbd px-1"> Failed </span>';
                        }
                    }
                },
                sortable: false,
            },
            {
                align: 'center',
                isNotDataProp: true,
                text: 'Action',
                sortable: false,
            }
        ];
    }

    public async GetVehicleTransferDetail(): Promise<void> {
        try {
            this.loading = true;
            const response = await vehicleInventoryService.GetVehicleTransferDetail(this.paginations, this.searchType);
            this.vehicleTransferList = response.results;
            this.paginations.totalItems = response.total;

        } finally {
            this.loading = false;
            this.setHeaders();
        }
    }

    public SearchVehicleTransferDetail() {
        this.paginations.page = 1;
        this.GetVehicleTransferDetail();
    }
}

